
/* eslint-disable */
import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import $ from 'jquery';
import moment from 'moment';

import { DatePickerField } from './fields/DateField';
import { DateRangeField } from './fields/DateRangeField';
import { DatePickerMinField } from './fields/DateMinField';
import { DatePickerMaxField } from './fields/DateMaxField';
import { DatePickerMinTodayField } from './fields/DateMinTodayField'
import { TextField, APLHA, ALPHANUMERIC } from './fields/TextField';
import { TextAreaField } from './fields/TextAreaField';
import { CheckBoxField } from './fields/CheckBoxField';
import { RadioBoxField } from './fields/RadioBoxField';
import { DropdownField } from './fields/DropdownField';
import InlineField from './fields/InlineField';

import { DropdownFieldView } from './fields/DropdownFieldView';
import { DropdownFieldEdit } from './fields/DropdownFieldEdit';

import { DropdownMultipleFieldView } from './fields/DropdownMultipleFieldView';
import { DropdownMultipleFieldEdit } from './fields/DropdownMultipleFieldEdit';

import { DropdownSearchField } from './fields/dropdown_search';
import { DropdownSearchMultipleField } from './fields/DropdownSearchMultipleField';
import { DropdownMultipleField } from './fields/DropdownMultipleField';
import { DecimalField, DECIMAL, asDecimal } from './fields/DecimalField';
import { IntegerField, INTEGER, asInteger } from './fields/IntegerField';
import { CurrencyField, CURRENCY, asCurrency } from './fields/CurrencyField';
import { DollarPercentField } from './fields/DollarPercentField';
import { CurrencyLabelField } from './fields/CurrencyLabelField';
import { MultiselectField } from './fields/MultiselectField';
import { DateTimeField } from './fields/DateTimeField';
import NewDateField from './fields/NewDateField';
import CreatableSelectInputField from './fields/CreatableSelectInputField';



import FormattedMessageFixed from './../Intl/FormatterMessageFixed';

import * as validations from './fields/Validation';
import Message from './fields/ValidationMessage';
import DefinedDropdownField from './fields/DefinedDropdownField';

export const renderCurrency = injectIntl(CurrencyField);
export const renderDollarPercent = injectIntl(DollarPercentField);
export const renderCurrencyLabel = injectIntl(CurrencyLabelField);
export const renderDatePicker = injectIntl(DatePickerField);
export const renderDatePickerMin = injectIntl(DatePickerMinField);
export const renderDatePickerMax = injectIntl(DatePickerMaxField);
export const renderDatePickerMinToday = injectIntl(DatePickerMinTodayField);
export const renderField = injectIntl(TextField);
export const renderTextArea = injectIntl(TextAreaField);
export const renderCheckbox = injectIntl(CheckBoxField);
export const renderRadiobox = injectIntl(RadioBoxField);
export const renderDecimal = injectIntl(DecimalField);
export const renderInteger = injectIntl(IntegerField);

export const renderDropDown = injectIntl(DropdownField);
export const renderDefinedDropdown = injectIntl(DefinedDropdownField);

export const renderDropDownEdit = injectIntl(DropdownFieldEdit);
export const renderDropDownView = injectIntl(DropdownFieldView);

export const renderDropDownMultipleView = injectIntl(DropdownMultipleFieldView);
export const renderDropDownMultipleEdit = injectIntl(DropdownMultipleFieldEdit);

export const renderSearchDropDown = injectIntl(DropdownSearchField);
export const renderSearchMultipleDropdown = injectIntl(DropdownSearchMultipleField)
export const renderDropDownMultiple = injectIntl(DropdownMultipleField);
export const renderDateRangePicker = injectIntl(DateRangeField);
export const renderDateTimePicker = injectIntl(DateTimeField);
export const renderNewDateField = injectIntl(NewDateField);

export const renderMultiselect = injectIntl(MultiselectField);
export const renderCreatableSelect = injectIntl(CreatableSelectInputField);

export const Formatter = (intl) => {
  return {
    toCurrency: (amount, currency) => {
      if (intl) {
        const formattedAmt = intl.formatNumber(amount, {
          currency: currency || 'USD',
          style: 'currency'
        });
        return formattedAmt;
      }
      return amount;
    },
    toDecimal: (value) => {
      if (intl) {
        const formattedValue = intl.formatNumber(value, {
          style: 'decimal',
          maximumFractionDigits: 2,
        });
        return formattedValue;
      }
      return value;
    },
    toPercentage: (value) => {
      if (intl) {
        const formattedValue = intl.formatNumber(value, {
          style: 'percent',
          maximumFractionDigits: 2,
        });
        return formattedValue;
      }
      return value;
    },
    toNumber(value) {
      return intl.formatNumber(Number(value));
    },
    toDate(dateStr) {
      const newDate = moment(dateStr).toDate();
      return intl.formatDate(newDate)
    },
    toDateTime(dateStr) {
      if (!moment(dateStr).isValid()) return '';

      const newDate = moment(dateStr).toDate();
      return intl.formatDate(newDate, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      })
    }
  };
};

export const Input = {
  INTEGER,
  asInteger,
  DECIMAL,
  asDecimal,
  CURRENCY,
  asCurrency,
  APLHA: APLHA,
  ALPHANUMERIC: ALPHANUMERIC,
};

export const Validate = {
  ...validations
};

export class renderRadio extends Component {
  render() {
    const { fieldId, input, required, label, disabled, className, meta: { touched, error, warning } } = this.props;
    let showError = touched && error ? "error" : "";
    let inputId = fieldId ? fieldId + '-' + input.name : null;

    return (
      <div className={`${required && 'required'} field ${showError} ${className || ''}`}>
        <div id={fieldId} className="ui radio checkbox">
          <input {...input} id={inputId || ''} type="radio" disabled={disabled} />
          <label htmlFor={inputId || ''} >
            {label}
          </label>
          <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
        </div>
      </div>
    );
  }
}

export class renderCustomButtonRadio extends Component {
  render() {
    const { fieldId, input, required, label, disabled, className, mata: { touched, error, warning } } = this.props;
    const showError = touched && error ? "error" : "";

    return (
      <div className={`${required && 'required'} field ${showError} ${className || ''}`}>
        <div id={fieldId} className="ui radio checkbox">
          <input {...input} type="radio" disabled={disabled} />
          <label>{label}</label>
          <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
        </div>
      </div>
    )
  }
}

export const renderToggle = injectIntl(({ intl, className, translation, input, required, label, type, displayType, meta: { touched, error, warning }, disabled }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderToggle' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} ${className} field`}>
      <div className={`ui toggle ${disabled ? 'disabled' : ''} checkbox`}>
        <input {...input} type="checkbox" />
        <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
        <label>{label}</label>
      </div>
    </div>
  )

});

export class renderHidden extends Component {
  render() {
    const { input, meta: { touched, error } } = this.props;
    return (
      <div>
        <input type="hidden" {...input} />
        {touched && error && <span>{error}</span>}
      </div>
    );
  }
}


export const renderSlider = injectIntl(({ intl, translation, input, required, label, type, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderSlider' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} field`}>
      <div className="ui slider checkbox">
        <input {...input} type="checkbox" />
        <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
        <label>{label}</label>
      </div>
    </div>
  )
});


export const renderActionInputField = injectIntl(({ intl, translation, input, required, label, placeholder, type, onClick, options = {}, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderActionInputField' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} field`}>
      <label>{label}</label>
      <div className="ui right action input field">
        <input readOnly={options.readOnly || false} {...input} type={type} placeholder={placeholder} />
        <div onClick={onClick} className="ui basic icon button" data-tooltip={options.tooltip} data-position="top center">
          {options.iconName ? <i className={`${options.iconName} icon`} ></i> : ""}
          {options.label}
        </div>
      </div>
      <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
    </div>
  )
});


export const renderSurchargeField = injectIntl(({ intl, translation, input, required, label, placeholder, onDollarClick, onPercentClick, isPercent, options = {}, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderSurchargeField' content={`${(!isPercent) ? "$" : ""}${input.value}${(isPercent) ? "%" : ""}`} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} field`}>
      <label>{label}</label>
      <div className="ui right action input field">
        <input readOnly={options.readOnly || false} {...input} type={"text"} />
        <div onClick={onDollarClick} className={`ui icon ${(!isPercent) ? "blue" : ""} button`} >
          $
        </div>
        <div onClick={onPercentClick} className={`ui icon ${(isPercent) ? "blue" : ""} button`} >
          %
        </div>
      </div>
      <div><Message show={touched} message={error} /><Message show={touched} message={warning} /></div>
    </div>
  )
});


export const renderDropDownResidential = injectIntl(({ intl, translation, input, required, label, type, disabled, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  return (
    <div className={`${required && 'required'} field`}>
      <label>{label}</label>
      <select {...input} className="ui dropdown" disabled={disabled} name={name}>
        <option key="08908f01bdcee81bd84f702b2e048356" value="08908f01bdcee81bd84f702b2e048356"><FormattedMessage id="admin.fieldhelper.label.residential" defaultMessage={`Residential`} /></option>
      </select>
      <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
    </div>
  );
});

export const renderSimpleCheckbox = ({ input, required, className = '', type, label, displayType, meta: { touched, error } }) => {

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderSimpleCheckbox' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} ${className}`}>
      <input {...input} type={type} />
      <label>{label || ""}</label>
    </div>
  );
}

export const renderFieldButton = ({ input, type, required, placeholder, className = '', style, onClick, icon, displayType, meta: { touched, error, warning } }) => {

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderFieldButton' content={input.value} />
    )
  }

  return (
    <div className={`${(required && 'required')} ${className}`} style={style}>
      <input {...input} type={type} placeholder={placeholder} />
      <div className="ui basic icon button" onClick={onClick}>
        <i className={icon}></i>
      </div>
      <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
    </div>
  );
}

/*
  Sample call for renderImage upload
  <Field name="image_thumb" className="ui centered floated card" label={`Upload an Image`} onSubmit={this.handleImageSubmit} onChange={this.handleFileImage} type="file" source={this.state.data_uri} component={renderImageUpload} />
*/
export const renderImageUpload = ({ input, type, required, placeholder, className = '', onChange, onSubmit, label, source, meta: { touched, error, warning } }) => {
  return (
    <div className={`${required && 'required'}  field`}>
      <div className={className}>
        <div className="content">
          <div className={`field`}><label>{label}</label></div>
          <form onSubmit={onSubmit} encType="multipart/form-data">
            <div className="ui input">
              <input {...input} type={type} onChange={onChange} />
            </div>
          </form>
          <div>
            <img className="ui fluid centered image" alt="" src={source} />
          </div>
        </div>
      </div>
      <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
    </div>
  );
}

export const renderActionMultipleDropDownField = injectIntl(({ intl, translation, input, label, list, type, options = {}, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  if (displayType === 'inline') {

    const content = list.reduce((res, doc) => {
      if (doc) {
        const isSelected = (input.value || []).indexOf(doc.id) > -1;
        return (isSelected) ? res.concat(doc.name) : res;
      }
    }, []);

    return <InlineField fieldType='renderActionMultipleDropDownField' value={input.value} content={content} label={label} />
  }

  return (
    <div className="field">
      <label>{label}</label>
      <div className="ui right action input field">
        <select {...input} className="ui fluid multiple selection search dropdown" multiple name={name} id={options.id}>
          {list.map((data) => {
            if (data.id) {
              return (<option key={data.id} value={data.id}>{data.name}</option>);
            }
            return null;
          })}
        </select>
        <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
        <div className="ui basic icon button" data-tooltip={options.tooltip} data-position="top center"><i className={`${options.iconName} icon`} onClick={options.onClick}></i></div>
      </div>
    </div>
  )
});

export const renderReadOnlyField = injectIntl(({ intl, translation, input, required, label, disabled, placeholder, type, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  let showError = touched && error ? "error" : "";
  let disabledLabel = disabled ? 'disabled' : '';
  let requiredLabel = required ? 'required' : '';

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderReadOnlyField' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${disabledLabel} ${requiredLabel} field ${showError}`}>
      <label>{label}</label>
      <div>
        <input {...input} type={type} placeholder={placeholder} readOnly disabled={disabled} />
        {/*  {touched && error && <span>{error}</span>}  */}
        <div>{touched && ((error && <span style={{ color: "#990000" }}>{error.message}</span>) || (warning && <span style={{ color: "#990000" }}>{warning.message}</span>))}</div>
      </div>
    </div>
  );
});

/* export class renderFieldURL extends Component { render() { ... }} */
export const renderFieldURL = injectIntl(({ intl, translation, input, required, label, disabled, type, displayType, meta: { touched, error, warning } }) => {

  if (intl && translation) {
    const labelObj = translation.label;
    const placeholderObj = translation.placeholder;
    if (labelObj && labelObj.message) {
      label = intl.formatMessage(labelObj.message, labelObj.params);
    }
    if (placeholderObj && placeholderObj.message) {
      placeholder = intl.formatMessage(placeholderObj.message, placeholderObj.params);
    }
  }

  let showError = touched && error ? "error" : "";

  if (displayType === 'inline') {
    return (
      <InlineField fieldType='renderFieldURL' content={input.value} label={label} />
    )
  }

  return (
    <div className={`${required && 'required'} field ${showError}`}>
      <label><FormattedMessageFixed id="admin.classification.general.image_url" defaultMessage={label} /></label>
      <div className="ui labeled fluid input">
        <div className="ui label">
          <FormattedMessage id="admin.hotkey.general.url" defaultMessage={`URL`} />
        </div>
        <input {...input} type={type} placeholder="http://" disabled={disabled} />
      </div>
      <div>{touched && ((error && <span style={{ color: "#990000" }}>{error.defaultMessage}</span>) || (warning && <span style={{ color: "#990000" }}>{warning.defaultMessage}</span>))}</div>
    </div>
  );
});


export class renderActionDropDownQuickAddField extends Component {
  componentDidMount() {
    const { input } = this.props;
    const name = input ? input.name : '';
    $(`.ui.dropdown.renderDropdown.${name}`).dropdown({
      forceSelection: false
    });

    $('#btn_add').popup({
      popup: $('.ui.popup'),
      on: 'click'
    });

  }

  showModal() {
    $('#QuickAddModal').modal('show');
  }

  render() {
    const { input, required, placeholder, label, list = [], options = {}, idField = 'id', id, displayField = 'name', disabled, meta: { touched, error, warning } } = this.props;
    let showError = touched && error ? "error" : "";

    return (
      <div>
        <div className="ui popup top left transition visible animating scale out" style={{ overflow: "visible" }}>
          {options.formValue}
        </div>

        <div className={`${required && 'required'} field ${showError}`}>
          <label>{label}</label>
          <div className="ui right action input field">
            <select {...input} className={`ui fluid multiple selection search dropdown renderDropdown ${name}`} multiple id={id} name={name} disabled={disabled}>
              <option value="">{placeholder}</option>
              {list && list.map((data) => {
                if (data[idField]) {
                  return (<option key={data[idField]} value={data[idField]}>{data[displayField]}</option>);
                }
                return null;
              })}
            </select>
            <div>{touched && ((error && <span style={{ color: "#990000" }}>{error}</span>) || (warning && <span style={{ color: "#990000" }}>{warning}</span>))}</div>
            <div className="ui basic icon button" id="btn_add" data-position="bottom right"><i className={`${options.iconName} icon`} onClick={this.showModal.bind(this)}></i></div>
          </div>
        </div>



      </div>
    );
  }
}
